export default __webpack_public_path__ + "cd056d5fb8b626384053fe7f879e6496.png";